import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
  className?: string;
}

export const ArrowUpRightIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 20 20'
    fill='none'
    className={className}
  >
    <path
      d='M5 5L15 15M15 15V5M15 15H5'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
